import { makeStyles } from "@material-ui/core/styles";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";

import {
  Checkbox,
  Collapse,
  FormControlLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
} from "@material-ui/core";
import {
  AddBoxOutlined,
  IndeterminateCheckBoxOutlined,
} from "@material-ui/icons";
import axios from "axios";
import Changes from "../../common/Changes";
import Loader from "../../common/loader/Loader";
import "./ProfileStraight.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  checkbox: {
    padding: "0 4px",
  },
  checkboxOut: {
    padding: "0",
    paddingRight: 4,
  },
  label: {
    fontSize: 12,
    margin: 0,
    padding: 0,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    minWidth: 120,
  },
}));

export default forwardRef(function ProfileStraight(props, ref) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const classes = useStyles();
  const [profileStraightOptions, setProfileStraightOptions] = React.useState(
    []
  );
  let idProfile = props.Profile.IdProfile;
  let profile = props.Profile;

  const [loading, setLoading] = useState(true);
  const requestProfileStraightOptions = () => {
    setLoading(true);
    const url =
      process.env.REACT_APP_API2_URL +
      "/Profile/PlayerProfileStraightLimit_GetInfo" +
      "?idProfile=" +
      idProfile;
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      setLoading(false);
      setProfileStraightOptions(response.data);
    });
  };

  //let IdPeriod = '0';
  useEffect(() => {
    requestProfileStraightOptions();
  }, []);
  useEffect(() => {
    requestProfileStraightOptions();
  }, [idProfile]);
  // const [selectedIdGame, setselectedIdGame] = useState();

  const updateStraight = () => {
    Promise.all(
      profileStraightOptions.map(
        ({
          idProfile: itemIdProfile,
          idSport,
          spreadPointsPurchaseMax,
          spreadPriceHalfPoints,
          spreadJuiceDefault,
          totalPointsPurchaseMax,
          totalPriceHalfPoints,
          totalJuiceDefault,
          on3Surcharge,
          off3Surcharge,
          on7Surcharge,
          off7Surcharge,
          surchargeTwice_3pts,
          surchargeTwice_7pts,
          skipHalfPoint,
          canBuyOn3,
          canBuyOff3,
          canBuyOn7,
          canBuyOff7,
        }) =>
          axios.post(
            `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileStraightLimit_Update`,
            {
              IdProfile: itemIdProfile,
              IdSport: idSport,
              SpreadPointsPurchaseMax: Number(spreadPointsPurchaseMax),
              SpreadPriceHalfPoints: Number(spreadPriceHalfPoints),
              SpreadJuiceDefault: Number(spreadJuiceDefault),
              TotalPointsPurchaseMax: Number(totalPointsPurchaseMax),
              TotalPriceHalfPoints: Number(totalPriceHalfPoints),
              TotalJuiceDefault: Number(totalJuiceDefault),
              On3Surcharge: Number(on3Surcharge),
              Off3Surcharge: Number(off3Surcharge),
              On7Surcharge: Number(on7Surcharge),
              Off7Surcharge: Number(off7Surcharge),
              SurchargeTwice_3pts: surchargeTwice_3pts,
              SurchargeTwice_7pts: surchargeTwice_7pts,
              SkipHalfPoint: skipHalfPoint,
              CanBuyOn3: canBuyOn3,
              CanBuyOff3: canBuyOff3,
              CanBuyOn7: canBuyOn7,
              CanBuyOff7: canBuyOff7,
              IdUser: Number(userInfo.userId),
            }
          )
      )
    ).then(() => requestProfileStraightOptions());
  };

  const [localProfile, setLocalProfile] = useState(props.Profile);

  const handleChange = (event, key, value) => {
    props.Profile[key] = event ? event.target.value : value;
    setLocalProfile({
      ...localProfile,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalProfile({
      ...props.Profile,
    });
  }, [props.Profile, setLocalProfile]);

  useImperativeHandle(ref, () => ({
    updateStraight,
  }));

  const handleChangeStraight = (event, indexSport, key, value) => {
    const items = [...profileStraightOptions];
    items[indexSport] = {
      ...items[indexSport],
      [key]: event ? event.target.value : value,
    };
    setProfileStraightOptions(items);
  };

  const [open, setOpen] = React.useState({
    Football: {
      Spread: true,
      Total: true,
      Surcharge: true,
      "Surcharge Twice When": false,
      "Can Buy Points": false,
    },
    "College Football": {
      Spread: true,
      Total: true,
      Surcharge: true,
      "Surcharge Twice When": false,
      "Can Buy Points": false,
    },
    Basketball: {
      Spread: true,
      Total: true,
      Surcharge: true,
    },
    "College Basketball": {
      Spread: true,
      Total: true,
      Surcharge: true,
    },
  });

  const toggleMenuState = useCallback(
    (sport, section) => {
      setOpen((current) => ({
        ...current,
        [sport]: {
          ...current[sport],
          [section]: !current?.[sport]?.[section],
        },
      }));
    },
    [setOpen]
  );

  const sportsMapping = () =>
    Object.entries({
      Football: profileStraightOptions.findIndex(
        ({ idSport }) => idSport?.trim().toUpperCase() === "NFL"
      ),
      "College Football": profileStraightOptions.findIndex(
        ({ idSport }) => idSport?.trim().toUpperCase() === "CFB"
      ),
      Basketball: profileStraightOptions.findIndex(
        ({ idSport }) => idSport?.trim().toUpperCase() === "NBA"
      ),
      "College Basketball": profileStraightOptions.findIndex(
        ({ idSport }) => idSport?.trim().toUpperCase() === "CBB"
      ),
    });

  const section = useCallback(
    (sport, section, children) => {
      const state = open[sport][section];
      return (
        <>
          <ListItem
            className="gap-1 !p-0"
            onClick={() => toggleMenuState(sport, section)}
          >
            <ListItemIcon className="!min-w-0 items-center">
              {state ? (
                <AddBoxOutlined className="!text-xs" />
              ) : (
                <IndeterminateCheckBoxOutlined className="!text-xs" />
              )}
            </ListItemIcon>
            <ListItemText
              className="!m-0"
              classes={{
                primary: "!text-xs ",
              }}
              primary={section}
            />
          </ListItem>
          <Collapse in={state} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {children}
            </List>
          </Collapse>
        </>
      );
    },
    [open, toggleMenuState]
  );

  const sport = useCallback(
    (title, indexSport) => (
      <div className="col-span-1 vertical-options">
        <h3>{title}</h3>
        <div className="flex flex-col gap-1 p-0">
          {section(
            title,
            "Spread",
            <>
              <ListItem sx={{ pl: 4 }} className="!py-1">
                <TextField
                  inputProps={{
                    style: {
                      padding: "5px 14px", // Adjust these values as needed
                      fontSize: "14px",
                    },
                  }}
                  className="flex-1"
                  size="small"
                  type="number"
                  label="Points Purchase Max"
                  value={
                    profileStraightOptions?.[indexSport].spreadPointsPurchaseMax
                  }
                  onChange={(event) =>
                    handleChangeStraight(
                      event,
                      indexSport,
                      "spreadPointsPurchaseMax",
                      undefined
                    )
                  }
                  variant="outlined"
                />
              </ListItem>
              <ListItem sx={{ pl: 4 }} className="!py-1">
                <TextField
                  inputProps={{
                    style: {
                      padding: "5px 14px", // Adjust these values as needed
                      fontSize: "14px",
                    },
                  }}
                  className="flex-1"
                  size="small"
                  type="number"
                  label="Free ½ points"
                  value={
                    profileStraightOptions?.[indexSport].spreadPriceHalfPoints
                  }
                  onChange={(event) =>
                    handleChangeStraight(
                      event,
                      indexSport,
                      "spreadPriceHalfPoints"
                    )
                  }
                  variant="outlined"
                />
              </ListItem>
              <ListItem sx={{ pl: 4 }} className="!py-1">
                <TextField
                  inputProps={{
                    style: {
                      padding: "5px 14px", // Adjust these values as needed
                      fontSize: "14px",
                    },
                  }}
                  className="flex-1"
                  size="small"
                  type="number"
                  label="Juice Default"
                  value={
                    profileStraightOptions?.[indexSport].spreadJuiceDefault
                  }
                  onChange={(event) =>
                    handleChangeStraight(
                      event,
                      indexSport,
                      "spreadJuiceDefault"
                    )
                  }
                  variant="outlined"
                />
              </ListItem>
            </>
          )}
          {section(
            title,
            "Total",
            <>
              <ListItem sx={{ pl: 4 }} className="!py-1">
                <TextField
                  inputProps={{
                    style: {
                      padding: "5px 14px", // Adjust these values as needed
                      fontSize: "14px",
                    },
                  }}
                  className="flex-1"
                  size="small"
                  type="number"
                  label="Points Purchase Max"
                  value={
                    profileStraightOptions?.[indexSport].totalPointsPurchaseMax
                  }
                  onChange={(event) =>
                    handleChangeStraight(
                      event,
                      indexSport,
                      "totalPointsPurchaseMax"
                    )
                  }
                  variant="outlined"
                />
              </ListItem>
              <ListItem sx={{ pl: 4 }} className="!py-1">
                <TextField
                  inputProps={{
                    style: {
                      padding: "5px 14px", // Adjust these values as needed
                      fontSize: "14px",
                    },
                  }}
                  className="flex-1"
                  size="small"
                  type="number"
                  label="Free ½ points"
                  value={
                    profileStraightOptions?.[indexSport].totalPriceHalfPoints
                  }
                  onChange={(event) =>
                    handleChangeStraight(
                      event,
                      indexSport,
                      "totalPriceHalfPoints"
                    )
                  }
                  variant="outlined"
                />
              </ListItem>
              <ListItem sx={{ pl: 4 }} className="!py-1">
                <TextField
                  inputProps={{
                    style: {
                      padding: "5px 14px", // Adjust these values as needed
                      fontSize: "14px",
                    },
                  }}
                  className="flex-1"
                  size="small"
                  type="number"
                  label="Juice Default"
                  value={profileStraightOptions?.[indexSport].totalJuiceDefault}
                  onChange={(event) =>
                    handleChangeStraight(event, indexSport, "totalJuiceDefault")
                  }
                  variant="outlined"
                />
              </ListItem>
            </>
          )}
          {["Football", "College Football"].includes(title) &&
            section(
              title,
              "Surcharge",
              <>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <TextField
                    inputProps={{
                      style: {
                        padding: "5px 14px", // Adjust these values as needed
                        fontSize: "14px",
                      },
                    }}
                    className="flex-1"
                    size="small"
                    type="number"
                    label="On 3"
                    value={profileStraightOptions?.[indexSport].on3Surcharge}
                    onChange={(event) =>
                      handleChangeStraight(event, indexSport, "on3Surcharge")
                    }
                    variant="outlined"
                  />
                </ListItem>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <TextField
                    inputProps={{
                      style: {
                        padding: "5px 14px", // Adjust these values as needed
                        fontSize: "14px",
                      },
                    }}
                    className="flex-1"
                    size="small"
                    type="number"
                    label="Off 3"
                    value={profileStraightOptions?.[indexSport].off3Surcharge}
                    onChange={(event) =>
                      handleChangeStraight(event, indexSport, "off3Surcharge")
                    }
                    variant="outlined"
                  />
                </ListItem>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <TextField
                    inputProps={{
                      style: {
                        padding: "5px 14px", // Adjust these values as needed
                        fontSize: "14px",
                      },
                    }}
                    className="flex-1"
                    size="small"
                    type="number"
                    label="On 7"
                    value={profileStraightOptions?.[indexSport].on7Surcharge}
                    onChange={(event) =>
                      handleChangeStraight(event, indexSport, "on7Surcharge")
                    }
                    variant="outlined"
                  />
                </ListItem>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <TextField
                    inputProps={{
                      style: {
                        padding: "5px 14px", // Adjust these values as needed
                        fontSize: "14px",
                      },
                    }}
                    className="flex-1"
                    size="small"
                    type="number"
                    label="Off 7"
                    value={profileStraightOptions?.[indexSport].off7Surcharge}
                    onChange={(event) =>
                      handleChangeStraight(event, indexSport, "off7Surcharge")
                    }
                    variant="outlined"
                  />
                </ListItem>
              </>
            )}
          <ListItem sx={{ pl: 4 }} className="!p-0">
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  classes={{
                    root: classes.checkboxOut,
                  }}
                  checked={profileStraightOptions?.[indexSport].skipHalfPoint}
                  onChange={(event) => {
                    handleChangeStraight(
                      undefined,
                      indexSport,
                      "skipHalfPoint",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Skip Half Point"
            />
          </ListItem>
          {["Football", "College Football"].includes(title) &&
            section(
              title,
              "Surcharge Twice When",
              <>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        classes={{
                          root: classes.checkbox,
                        }}
                        checked={
                          profileStraightOptions?.[indexSport]
                            .surchargeTwice_3pts
                        }
                        onChange={(event) => {
                          handleChangeStraight(
                            undefined,
                            indexSport,
                            "surchargeTwice_3pts",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Buying Through 3pts"
                  />
                </ListItem>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        classes={{
                          root: classes.checkbox,
                        }}
                        checked={
                          profileStraightOptions?.[indexSport]
                            .surchargeTwice_7pts
                        }
                        onChange={(event) => {
                          handleChangeStraight(
                            undefined,
                            indexSport,
                            "surchargeTwice_7pts",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Buying Through 7pts"
                  />
                </ListItem>
              </>
            )}
          {["Football", "College Football"].includes(title) &&
            section(
              title,
              "Can Buy Points",
              <>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        classes={{
                          root: classes.checkbox,
                        }}
                        checked={profileStraightOptions?.[indexSport].canBuyOn3}
                        onChange={(event) => {
                          handleChangeStraight(
                            undefined,
                            indexSport,
                            "canBuyOn3",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="On 3"
                  />
                </ListItem>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        classes={{
                          root: classes.checkbox,
                        }}
                        checked={
                          profileStraightOptions?.[indexSport].canBuyOff3
                        }
                        onChange={(event) => {
                          handleChangeStraight(
                            undefined,
                            indexSport,
                            "canBuyOff3",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Off 3"
                  />
                </ListItem>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        classes={{
                          root: classes.checkbox,
                        }}
                        checked={profileStraightOptions?.[indexSport].canBuyOn7}
                        onChange={(event) => {
                          handleChangeStraight(
                            undefined,
                            indexSport,
                            "canBuyOn7",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="On 7"
                  />
                </ListItem>
                <ListItem sx={{ pl: 4 }} className="!py-1">
                  <FormControlLabel
                    classes={{ label: classes.label }}
                    control={
                      <Checkbox
                        size="small"
                        classes={{
                          root: classes.checkbox,
                        }}
                        checked={
                          profileStraightOptions?.[indexSport].canBuyOff7
                        }
                        onChange={(event) => {
                          handleChangeStraight(
                            undefined,
                            indexSport,
                            "canBuyOff7",
                            event.target.checked
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Off 7"
                  />
                </ListItem>
              </>
            )}
        </div>
        <Changes
          title={`${title} Straight Limits for Player Profile Changes`}
          buttonText="Changes"
          params={{
            ChangeType: 15,
            IdSport: profileStraightOptions?.[indexSport].idSport,
            Param1: profileStraightOptions?.[indexSport].idProfile,
            Param2: 0,
            Param3: 0,
          }}
        />
      </div>
    ),
    [profileStraightOptions, section, classes]
  );

  if (loading && profileStraightOptions?.length === 0) return <Loader></Loader>;
  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="grid grid-cols-2 col-span-2 gap-4">
        {sportsMapping().map(
          ([title, index]) => index != -1 && sport(title, index)
        )}
      </div>
      <div className="flex flex-col col-span-1 gap-4">
        <div className="vertical-options">
          <h3>If Bets</h3>
          <TextField
            inputProps={{
              style: {
                padding: "5px 14px", // Adjust these values as needed
                fontSize: "14px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            className="flex-1"
            size="small"
            type="number"
            label="Max Number of Parlays"
            value={localProfile?.iL_MaxParlays}
            onChange={(event) => handleChange(event, "iL_MaxParlays")}
            variant="outlined"
          />
          <TextField
            inputProps={{
              style: {
                padding: "5px 14px", // Adjust these values as needed
                fontSize: "14px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            className="flex-1"
            size="small"
            type="number"
            label="Max Level of Parlays"
            value={localProfile?.iL_MaxLevelParlays}
            onChange={(event) => handleChange(event, "iL_MaxLevelParlays")}
            variant="outlined"
          />
          <TextField
            inputProps={{
              style: {
                padding: "5px 14px", // Adjust these values as needed
                fontSize: "14px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            className="flex-1"
            size="small"
            type="number"
            label="Max Number of Teasers"
            value={localProfile?.iL_MaxTeasers}
            onChange={(event) => handleChange(event, "iL_MaxTeasers")}
            variant="outlined"
          />
          <TextField
            inputProps={{
              style: {
                padding: "5px 14px", // Adjust these values as needed
                fontSize: "14px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            className="flex-1"
            size="small"
            type="number"
            label="Max Level of Teasers"
            value={localProfile?.iL_MaxLevelTeasers}
            onChange={(event) => handleChange(event, "iL_MaxLevelTeasers")}
            variant="outlined"
          />
          <TextField
            inputProps={{
              style: {
                padding: "5px 14px", // Adjust these values as needed
                fontSize: "14px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            className="flex-1"
            size="small"
            type="number"
            label="Max Number of Straights"
            value={localProfile?.iL_MaxNumberSB}
            onChange={(event) => handleChange(event, "iL_MaxNumberSB")}
            variant="outlined"
          />
          <TextField
            inputProps={{
              style: {
                padding: "5px 14px", // Adjust these values as needed
                fontSize: "14px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            className="flex-1"
            size="small"
            type="number"
            label="Odds Limit"
            value={localProfile?.iLOddslimit}
            onChange={(event) => handleChange(event, "iLOddslimit")}
            variant="outlined"
          />
          <FormControlLabel
            classes={{ label: classes.label }}
            control={
              <Checkbox
                size="small"
                classes={{
                  root: classes.checkbox,
                }}
                checked={localProfile?.iL_AskAmount}
                onChange={(event) => {
                  handleChange(undefined, "iL_AskAmount", event.target.checked);
                }}
                color="primary"
              />
            }
            label="Ask Amount for All Wagers"
          />
          <FormControlLabel
            classes={{ label: classes.label }}
            control={
              <Checkbox
                size="small"
                classes={{
                  root: classes.checkbox,
                }}
                checked={localProfile?.iL_AllowChildHigher}
                onChange={(event) => {
                  handleChange(
                    undefined,
                    "iL_AllowChildHigher",
                    event.target.checked
                  );
                }}
                color="primary"
              />
            }
            label="Allow Higher Child Risk"
          />
        </div>

        <div className="vertical-options">
          <FormControlLabel
            classes={{ label: classes.label }}
            control={
              <Checkbox
                size="small"
                classes={{
                  root: classes.checkbox,
                }}
                checked={localProfile?.sL_AlwaysActionMLBTotals}
                onChange={(event) => {
                  handleChange(
                    undefined,
                    "sL_AlwaysActionMLBTotals",
                    event.target.checked
                  );
                }}
                color="primary"
              />
            }
            label="Allow Action on MLB Total / Runline"
          />
        </div>
      </div>
    </div>
  );
});
